import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// ✅ ADD THIS
import { ThemeProvider } from "./context/ThemeContext";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    {/* ✅ ThemeProvider yahin lagega */}
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
